import { atom } from 'jotai';
import { FloorPrice } from 'types';

export const floorPricesAtom = atom<FloorPrice[]>([]);
